import type { SVGProps } from "react"

const TransferProtocol = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 3436" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 8911">
      <g data-name="Group 8910" clipPath="url(#prefix__a)">
        <path data-name="Path 60338" d="M175 0A175 175 0 110 175 175 175 0 01175 0" fill="#fff" />
        <path
          data-name="Path 60339"
          d="M264.371 310.43H84.009a8.047 8.047 0 01-8.047-8.047V40.632a8.047 8.047 0 018.047-8.047h180.362a8.047 8.047 0 018.047 8.047v261.751a8.047 8.047 0 01-8.047 8.047"
          fill="#fff"
        />
        <path
          data-name="Path 60340"
          d="M264.37 311.931H84.008a9.557 9.557 0 01-9.546-9.547V40.633a9.557 9.557 0 019.546-9.547H264.37a9.557 9.557 0 019.547 9.547v261.751a9.557 9.557 0 01-9.547 9.547M84.008 34.086a6.554 6.554 0 00-6.546 6.547v261.751a6.554 6.554 0 006.546 6.547H264.37a6.553 6.553 0 006.547-6.547V40.633a6.553 6.553 0 00-6.547-6.547z"
          fill="#1d1d1b"
        />
        <path data-name="Path 60341" d="M210.22 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60342" d="M214.017 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60343" d="M217.814 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60344" d="M221.611 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
        <path data-name="Path 60345" d="M206.423 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60346" d="M210.22 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60347" d="M206.423 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60348" d="M202.626 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60349" d="M214.017 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60350" d="M217.814 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60351" d="M221.611 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
        <path data-name="Path 60352" d="M225.407 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60353" d="M229.2 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60354" d="M233 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60355" d="M236.8 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60356" d="M240.6 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60357" d="M225.407 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60358" d="M229.2 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60359" d="M233 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60360" d="M236.8 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60361" d="M240.6 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60362" d="M244.392 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60363" d="M248.189 316.466a.475.475 0 10.474.475.474.474 0 00-.474-.475" fill="#1d1d1b" />
        <path data-name="Path 60364" d="M251.986 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
        <path data-name="Path 60365" d="M255.782 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60366" d="M259.579 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60367" d="M244.392 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60368" d="M248.189 312.669a.475.475 0 10.474.476.475.475 0 00-.474-.476" fill="#1d1d1b" />
        <path data-name="Path 60369" d="M251.986 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
        <path data-name="Path 60370" d="M255.782 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60371" d="M259.579 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60372" d="M263.376 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60373" d="M267.173 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60374" d="M270.97 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60375" d="M274.767 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60376" d="M263.376 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60377" d="M267.173 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60378" d="M270.97 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60379" d="M274.767 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60380" d="M138.079 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60381" d="M141.876 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60382" d="M145.673 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60383" d="M149.47 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60384" d="M134.283 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
        <path data-name="Path 60385" d="M138.079 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60386" d="M134.283 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
        <path data-name="Path 60387" d="M130.486 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
        <path data-name="Path 60388" d="M141.876 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60389" d="M145.673 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60390" d="M149.47 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60391" d="M153.267 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60392" d="M157.064 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60393" d="M160.86 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60394" d="M164.657 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60395" d="M168.454 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60396" d="M153.267 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60397" d="M157.064 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60398" d="M160.86 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60399" d="M164.657 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60400" d="M168.454 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60401" d="M172.251 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60402" d="M176.048 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60403" d="M179.845 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60404" d="M183.642 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60405" d="M187.439 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60406" d="M172.251 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60407" d="M176.048 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60408" d="M179.845 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60409" d="M183.642 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60410" d="M187.439 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60411" d="M84.923 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60412" d="M88.72 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60413" d="M92.517 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60414" d="M96.314 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60415" d="M81.126 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60416" d="M84.923 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60417" d="M81.126 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60418" d="M77.329 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60419" d="M88.72 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60420" d="M92.517 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60421" d="M96.314 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60422" d="M100.11 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60423" d="M103.907 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60424" d="M107.7 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60425" d="M111.5 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60426" d="M115.3 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60427" d="M100.11 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60428" d="M103.907 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60429" d="M107.7 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60430" d="M111.5 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60431" d="M115.3 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60432" d="M119.1 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60433" d="M122.892 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60434" d="M126.689 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60435" d="M130.486 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
        <path data-name="Path 60436" d="M119.1 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60437" d="M122.892 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60438" d="M126.689 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60439" d="M191.236 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60440" d="M195.032 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60441" d="M198.829 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60442" d="M202.626 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60443" d="M191.236 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60444" d="M195.032 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60445" d="M198.829 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60446" d="M278.563 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60447" d="M274.767 308.873a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60448" d="M278.563 308.873a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60449" d="M274.767 305.076a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60450" d="M278.563 305.076a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60451" d="M274.767 301.279a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60452" d="M274.767 297.482a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60453" d="M278.563 301.279a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60454" d="M278.563 297.482a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60455" d="M274.767 293.685a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60456" d="M278.563 293.685a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60457" d="M274.767 289.888a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60458" d="M278.563 289.888a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60459" d="M274.767 286.091a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60460" d="M278.563 286.091a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60461" d="M274.767 282.3a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60462" d="M274.767 278.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60463" d="M278.563 282.3a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60464" d="M278.563 278.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60465" d="M274.767 274.7a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60466" d="M278.563 274.7a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60467" d="M274.767 270.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60468" d="M278.563 270.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60469" d="M274.767 267.107a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60470" d="M278.563 267.107a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60471" d="M274.767 263.31a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60472" d="M278.563 263.31a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60473" d="M274.767 259.513a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60474" d="M278.563 259.513a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60475" d="M274.767 255.716a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60476" d="M274.767 251.92a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60477" d="M278.563 255.716a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60478" d="M278.563 251.92a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60479" d="M274.767 248.123a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60480" d="M278.563 248.123a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60481" d="M274.767 244.326a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60482" d="M278.563 244.326a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60483" d="M274.767 240.529a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60484" d="M278.563 240.529a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60485" d="M274.767 236.732a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60486" d="M274.767 232.935a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60487" d="M278.563 236.732a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60488" d="M278.563 232.935a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60489" d="M274.767 229.138a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60490" d="M278.563 229.138a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60491" d="M274.767 225.341a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60492" d="M278.563 225.341a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
        <path data-name="Path 60493" d="M274.767 221.545a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60494" d="M278.563 221.545a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60495" d="M274.767 217.748a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60496" d="M278.563 217.748a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60497" d="M278.563 213.951a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60498" d="M274.767 213.951a.476.476 0 10.437.29.475.475 0 00-.437-.29" fill="#1d1d1b" />
        <path
          data-name="Path 60499"
          d="M274.767 210.154a.475.475 0 00-.475.475.475.475 0 00.95 0 .475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path data-name="Path 60500" d="M278.563 210.154a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60501" d="M274.767 206.357a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60502" d="M278.563 206.357a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60503" d="M274.767 202.56a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60504" d="M278.563 202.56a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60505" d="M274.767 198.763a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60506" d="M274.767 194.967a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60507" d="M278.563 198.763a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60508" d="M278.563 194.967a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60509" d="M274.767 191.17a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60510" d="M278.563 191.17a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60511" d="M274.767 187.373a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60512" d="M278.563 187.373a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60513" d="M274.767 183.576a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60514" d="M278.563 183.576a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60515" d="M274.767 179.779a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60516" d="M274.767 175.982a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60517" d="M278.563 179.779a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60518" d="M278.563 175.982a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60519" d="M274.767 172.185a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60520" d="M278.563 172.185a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60521" d="M274.767 168.388a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60522" d="M278.563 168.388a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60523" d="M274.767 164.592a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60524" d="M278.563 164.592a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60525" d="M274.767 160.795a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60526" d="M278.563 160.795a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60527" d="M274.767 157a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60528" d="M278.563 157a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60529" d="M274.767 153.2a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60530" d="M274.767 149.4a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60531" d="M278.563 153.2a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60532" d="M278.563 149.4a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60533" d="M274.767 145.607a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60534" d="M278.563 145.607a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path
          data-name="Path 60535"
          d="M274.767 141.81a.475.475 0 00-.475.475V142.298a.475.475 0 00.95 0V142.285a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path data-name="Path 60536" d="M278.563 141.81a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path
          data-name="Path 60537"
          d="M274.767 138.014a.475.475 0 00-.475.475V138.502a.475.475 0 10.95 0V138.489a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60538"
          d="M278.563 138.014a.475.475 0 00-.475.475V138.502a.475.475 0 10.95 0V138.489a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60539"
          d="M274.767 134.217a.475.475 0 00-.475.475V134.705a.475.475 0 00.95 0V134.692a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60540"
          d="M274.767 130.42a.475.475 0 00-.475.475V130.908a.475.475 0 00.95 0V130.895a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60541"
          d="M278.563 134.217a.475.475 0 00-.475.475V134.705a.475.475 0 10.95 0V134.692a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60542"
          d="M278.563 130.42a.475.475 0 00-.475.475V130.908a.475.475 0 10.95 0V130.895a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60543"
          d="M274.767 126.623a.475.475 0 00-.475.475V127.111a.475.475 0 00.95 0V127.098a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60544"
          d="M278.563 126.623a.475.475 0 00-.475.475V127.111a.475.475 0 10.95 0V127.098a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60545"
          d="M274.767 122.826a.475.475 0 00-.475.475V123.314a.475.475 0 00.95 0V123.301a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60546"
          d="M278.563 122.826a.475.475 0 00-.475.475V123.314a.475.475 0 10.95 0V123.301a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60547"
          d="M274.767 119.029a.475.475 0 00-.475.475V119.517a.475.475 0 00.95 0V119.504a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60548"
          d="M278.563 119.029a.475.475 0 00-.475.475V119.517a.475.475 0 10.95 0V119.504a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60549"
          d="M274.767 115.232a.475.475 0 00-.475.475V115.72a.475.475 0 00.95 0V115.707a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60550"
          d="M278.563 115.232a.475.475 0 00-.475.475V115.72a.475.475 0 10.95 0V115.707a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60551"
          d="M274.767 111.436a.475.475 0 00-.475.475V111.924a.475.475 0 00.95 0V111.911a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60552"
          d="M278.563 111.436a.475.475 0 00-.475.475V111.924a.475.475 0 10.95 0V111.911a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60553"
          d="M274.767 107.639a.475.475 0 00-.475.475V108.127a.475.475 0 00.95 0V108.114a.475.475 0 00-.475-.475"
          fill="#1d1d1b"
        />
        <path data-name="Path 60554" d="M274.767 103.855a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60555" d="M278.563 107.652a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60556" d="M278.563 103.855a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60557" d="M274.767 100.058a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60558" d="M278.563 100.058a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60559" d="M274.767 96.262a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60560" d="M278.563 96.262a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60561" d="M274.767 92.465a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60562" d="M278.563 92.465a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60563" d="M274.767 88.668a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60564" d="M278.563 88.668a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60565" d="M274.767 84.871a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60566" d="M278.563 84.871a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60567" d="M274.767 81.074a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60568" d="M274.767 77.277a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60569" d="M278.563 81.074a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60570" d="M278.563 77.277a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60571" d="M274.767 73.48a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60572" d="M278.563 73.48a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60573" d="M274.767 69.683a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60574" d="M278.563 69.683a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60575" d="M274.767 65.887a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60576" d="M278.563 65.887a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60577" d="M274.767 62.09a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60578" d="M274.767 58.293a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60579" d="M278.563 62.09a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60580" d="M278.563 58.293a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60581" d="M274.767 54.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60582" d="M278.563 54.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60583" d="M274.767 50.7a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60584" d="M278.563 50.7a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60585" d="M274.767 46.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60586" d="M278.563 46.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60587" d="M274.767 43.1a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60588" d="M278.563 43.1a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60589" d="M274.767 39.309a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path data-name="Path 60590" d="M278.563 40.258a.475.475 0 10-.475-.475.475.475 0 00.475.475" fill="#1d1d1b" />
        <path data-name="Path 60591" d="M274.767 35.512a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
        <path
          data-name="Path 60592"
          d="M253.776 56.089H195.2a2.114 2.114 0 110-4.228h58.579a2.114 2.114 0 010 4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60593"
          d="M130.477 126.238H103.3a2.114 2.114 0 000 4.228h27.175a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60594"
          d="M130.477 133.916H103.3a2.114 2.114 0 100 4.228h27.175a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60595"
          d="M161.943 126.238h-18.225a2.114 2.114 0 000 4.228h18.225a2.114 2.114 0 100-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60596"
          d="M161.943 133.916h-18.225a2.114 2.114 0 000 4.228h18.225a2.114 2.114 0 100-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60597"
          d="M161.974 91.534h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60598"
          d="M161.974 98.934h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60599"
          d="M161.974 106.333h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60600"
          d="M103.634 85.192H138a2.114 2.114 0 100-4.228h-34.366a2.114 2.114 0 100 4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60601"
          d="M249.909 176.542h-24.472a2.13 2.13 0 010-4.26h24.472a2.13 2.13 0 010 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60602"
          d="M249.909 185.062h-24.472a2.13 2.13 0 010-4.26h24.472a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60603"
          d="M249.909 193.583h-24.472a2.13 2.13 0 010-4.26h24.472a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60604"
          d="M249.909 202.1h-24.472a2.13 2.13 0 010-4.26h24.472a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60605"
          d="M249.909 210.624h-24.472a2.13 2.13 0 010-4.26h24.472a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60606"
          d="M118.135 254.05H93.663a2.13 2.13 0 010-4.26h24.472a2.13 2.13 0 010 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60607"
          d="M158.749 176.542H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 010 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60608"
          d="M158.749 185.062H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60609"
          d="M158.749 193.583H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60610"
          d="M158.749 202.1H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60611"
          d="M158.749 210.624H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60612"
          d="M134.916 246.118H93.663a2.13 2.13 0 110-4.26h41.253a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60613"
          d="M137.263 161.211h-43.6a2.13 2.13 0 110-4.26h43.6a2.13 2.13 0 110 4.26"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60614"
          d="M123.461 47.225H120.6a.858.858 0 00-.857.858v.222l-5.016-2.051a3.034 3.034 0 00-2.518.088l-3.129 1.567-.258-.257a3.032 3.032 0 00-3.295-.669l-4.084 1.693v-.593a.858.858 0 00-.858-.858h-2.858a.859.859 0 00-.858.858v9.722a.859.859 0 00.858.858h2.859a.858.858 0 00.858-.858v-.1a4.925 4.925 0 013.034 1.273l2.512 2.279a2.357 2.357 0 001.65.667 2.4 2.4 0 001.705-.708 2.363 2.363 0 00.641-1.178h.1a2.377 2.377 0 002.37-2.166 2.469 2.469 0 001.282-.523l1.618.554a2.959 2.959 0 00.964.161 3.11 3.11 0 002.061-.8l.366-.38v.913a.858.858 0 00.857.858h2.86a.859.859 0 00.858-.858v-9.714a.859.859 0 00-.858-.858m-23.735 9.722h-1.144v-8.006h1.144v1a.176.176 0 000 .023zm13.039-.962l-1.121-1.121a.881.881 0 00-.209-.154.858.858 0 00-1.006 1.367l1.12 1.12a.66.66 0 010 .936.677.677 0 01-.935 0l-.186-.186-.085-.09-1.121-1.12a.859.859 0 00-1.217 1.214l1.168 1.169a.655.655 0 01.149.419.678.678 0 01-1.16.47l-2.533-2.3a6.637 6.637 0 00-4.187-1.721v-5.456l4.735-1.962a1.336 1.336 0 011.431.3l.025.026a2.315 2.315 0 001.83 3.733 2.334 2.334 0 001.044-.247l.41-.207L113.745 55a.7.7 0 01-.04.989.675.675 0 01-.937 0m5.427.046a1.327 1.327 0 01-1.287.254l-1.289-.442a2.4 2.4 0 00-.655-2.054l-2.432-2.432 1.336-.673a.858.858 0 00-.77-1.533l-2.4 1.207-.02.011-.944.475a.6.6 0 01-.695-.112.6.6 0 01.157-.963l3.78-1.893a1.312 1.312 0 011.1-.035l5.67 2.318v4.26zm4.408.916h-1.144v-7.359-.651h1.141z"
          fill="#1d1d1b"
        />
        <path
          data-name="Path 60615"
          d="M173.712 119.53H91.534a.5.5 0 01-.5-.5V72.5a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v46.53a.5.5 0 01-.5.5m-81.678-1h81.178V73H92.034z"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60616"
          d="M244.09 91.534h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60617"
          d="M244.09 98.934h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60618"
          d="M244.09 106.333h-58.579a2.114 2.114 0 100 4.228h58.579a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60619"
          d="M185.75 85.192h34.365a2.114 2.114 0 000-4.228H185.75a2.114 2.114 0 000 4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60620"
          d="M255.89 119.53h-82.178a.5.5 0 01-.5-.5V72.5a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v46.53a.5.5 0 01-.5.5m-81.678-1h81.179V73h-81.179z"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60621"
          d="M173.712 145.851H91.534a.5.5 0 01-.5-.5V119.03a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v26.321a.5.5 0 01-.5.5m-81.678-1h81.178V119.53H92.034z"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60622"
          d="M212.656 126.238h-27.175a2.114 2.114 0 000 4.228h27.175a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60623"
          d="M212.656 133.916h-27.175a2.114 2.114 0 100 4.228h27.175a2.114 2.114 0 100-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60624"
          d="M244.122 126.238H225.9a2.114 2.114 0 000 4.228h18.226a2.114 2.114 0 000-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60625"
          d="M244.122 133.916H225.9a2.114 2.114 0 000 4.228h18.226a2.114 2.114 0 100-4.228"
          fill="#c5c5c4"
        />
        <path
          data-name="Path 60626"
          d="M255.89 145.851h-82.178a.5.5 0 01-.5-.5V119.03a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v26.321a.5.5 0 01-.5.5m-81.678-1h81.179V119.53h-81.179z"
          fill="#c5c5c4"
        />
        <path data-name="Path 60627" d="M255.89 167.246H91.534a.5.5 0 010-1H255.89a.5.5 0 110 1" fill="#c5c5c4" />
        <path data-name="Path 60628" d="M255.89 216.659H91.534a.5.5 0 010-1H255.89a.5.5 0 110 1" fill="#c5c5c4" />
        <path
          data-name="Path 60629"
          d="M135.009 281.22h-32.154a1.434 1.434 0 010-2.869h32.154a1.434 1.434 0 010 2.869"
          fill="#c5c5c4"
        />
        <path data-name="Path 60630" d="M146.331 272.353h-54.8a.5.5 0 010-1h54.8a.5.5 0 010 1" fill="#c5c5c4" />
        <path
          data-name="Path 60631"
          d="M244.568 281.22h-32.154a1.434 1.434 0 010-2.869h32.154a1.434 1.434 0 010 2.869"
          fill="#c5c5c4"
        />
        <path data-name="Path 60632" d="M255.89 272.353h-54.8a.5.5 0 010-1h54.8a.5.5 0 110 1" fill="#c5c5c4" />
      </g>
    </g>
  </svg>
)
export { TransferProtocol }
